import { gql } from "@apollo/client";

export const GET_STOCK_DETAILS = gql`
  query getPublicStockDetail($stockId: ID!, $exchange: String) {
    getPublicStockDetail(stockId: $stockId, exchange: $exchange) {
      id
      ticker
      image
      avgFourmScore
      companyName
      exchange
      isEtf
      isFund
      hasLimitedData
      currency
      share_price
      exchangeShortName
      summary
      mosPer
      newScore
      description
      url
    }
  }
`;

export const GET_STOCK_META_DATA = gql`
  query getStockMetaData($stockId: ID!, $exchange: String) {
    getStockMetaData(stockId: $stockId, exchange: $exchange) {
      ticker
      image
      companyName
      exchange
    }
  }
`;

export const GET_STOCK_NEWS = gql`
  query getPublicStockNews(
    $stockId: ID!
    $exchange: String
    $limit: Int
    $page: Int
  ) {
    getPublicStockNews(
      stockId: $stockId
      exchange: $exchange
      page: $page
      limit: $limit
    ) {
      count
      data {
        news {
          faviconUrl
          publishedDate
          title
          image
          image
          site
          text
          url
        }
      }
    }
  }
`;

export const GET_STOCK_HISTORY = gql`
  query getPublicStockHistory(
    $stockId: ID
    $exchange: String
    $period: String
  ) {
    getPublicStockHistory(
      stockId: $stockId
      exchange: $exchange
      period: $period
    )
  }
`;

export const GET_PROJECTION = gql`
  query getPublicProjection($stockId: ID!, $exchange: String) {
    getPublicProjection(stockId: $stockId, exchange: $exchange)
  }
`;

export const SIMILAR_STOCK = gql`
  query getPublicStockToSimilarStock(
    $stockId: ID!
    $exchange: String
    $limit: Int
    $page: Int
  ) {
    getPublicStockToSimilarStock(
      stockId: $stockId
      exchange: $exchange
      page: $page
      limit: $limit
    ) {
      count
      data {
        id
        ticker
        exchangeShortName
        image
        newScore
        companyName
        currency
        share_price
      }
    }
  }
`;

export const GET_OPENAI_RESPONSE = gql`
  query getPublicOpenAiResponse($stockId: ID, $exchange: String) {
    getPublicOpenAiResponse(stockId: $stockId, exchange: $exchange)
  }
`;
export const GET_PUBLIC_STOCK_LIST = gql`
  query GetPublicStockList($page: Number, $limit: Number, $country: String) {
    getPublicStockList(page: $page, limit: $limit, country: $country) {
      count
      data {
        id
        ticker
        exchangeShortName
      }
    }
  }
`;

export const GET_BUYING_OPPORTUNITIES = gql`
  query getPublicBuyingOpportunities {
    getPublicBuyingOpportunities {
      _id
      ticker
      companyName
      image
      year
      investment
      currency
      currentValue
      exchangeShortName
    }
  }
`;

export const GET_BANNERS = gql`
  query getRandomBanners {
    getRandomBanners {
      _id
      bannerImage
      customerName
      bannerName
      bannerLink
    }
  }
`;
